import React, { Suspense } from 'react';

import { MainScreen, Loader, Facts, PlasticLife, Lifehacks,  Video, Arranged, Test, Footer } from './components';
const Location = React.lazy(() => import('./components/Location'));
function App() {


  return (
    <div className="App">
      <MainScreen />
      <Video />
      <Facts />
      <PlasticLife />
      <Lifehacks />
       
    
      <Arranged />
      <Suspense fallback={<Loader />}>
        <Location />
      </Suspense>
      <Test />
      <Footer />
    </div>
  );
}

export default App;
